module.exports = __webpack_public_path__ + "static/media/ProximaNova-Bold.48deb1f1.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/ProximaNova-Bold.eot
// module id = 3538
// module chunks = 68